/*
 * Project: bellcloud
 * File: packages/types/device/lite/sensors.ts
 * Author: SWAN
 * Created: 2025-07-08 13:50:58
 * Description:
 */

import type { Option } from '../../common/option';

export enum SensorType {
  O2LF = 0,
  CO = 1, // CO (DD)
  H2S = 2, // H2S (DD)
  LEL_LPC = 3, // LEL - SGX
  CO2_CRANBERRY = 4,
  LEL_IR = 5, // CH4 - Cranberry
  O2 = 6,
  LEL_1Series = 7,
  CO_ALPHA = 8, // CO (Alpha)
  H2S_ALPHA = 9, // H2S (Alpha)
  CO2_CRANBERRY_VOL = 250, // CO2 %VOL 단위용 (펌웨어 코드 아님, UI 전용 합성 값)
  NO_SENSOR = 255,
}

// 센서 기본 정보 (기능 플래그는 constraints에 있음)
export type SensorTypeInfo = {
  index: number; // ui show order
  label: string;
};

// 센서 타입 옵션 (Select box용)
export type SensorTypeOption = Option<SensorType>;

export const SENSOR_TYPE_INFO: Record<SensorType, SensorTypeInfo> = {
  [SensorType.O2LF]: {
    index: 0,
    label: 'O2LF',
  },
  [SensorType.CO]: {
    index: 3,
    label: 'CO',
  },
  [SensorType.H2S]: {
    index: 2,
    label: 'H2S',
  },
  [SensorType.CO_ALPHA]: {
    index: 3,
    label: 'CO',
  },
  [SensorType.H2S_ALPHA]: {
    index: 2,
    label: 'H2S',
  },
  [SensorType.LEL_LPC]: {
    index: 1,
    label: 'EX-LPC',
  },
  [SensorType.LEL_1Series]: {
    index: 1,
    label: 'EX_1Series',
  },
  [SensorType.CO2_CRANBERRY]: {
    index: 4,
    label: 'CO2',
  },
  [SensorType.CO2_CRANBERRY_VOL]: {
    index: 4,
    label: 'CO2',
  },
  [SensorType.O2]: {
    index: 0,
    label: 'O2',
  },
  [SensorType.LEL_IR]: {
    index: 1,
    label: 'EX_IR',
  },
  [SensorType.NO_SENSOR]: {
    index: 0,
    label: '',
  },
};

export const SENSOR_TYPE_MAP: Record<string, SensorType> = {
  O2LF: SensorType.O2LF,
  CO: SensorType.CO,
  H2S: SensorType.H2S,
  LEL_LPC: SensorType.LEL_LPC,
  CO2_CRANBERRY: SensorType.CO2_CRANBERRY,
  LEL_IR: SensorType.LEL_IR,
  O2: SensorType.O2,
  LEL_1Series: SensorType.LEL_1Series,
  CO_ALPHA: SensorType.CO_ALPHA,
  H2S_ALPHA: SensorType.H2S_ALPHA,
  CO2_CRANBERRY_VOL: SensorType.CO2_CRANBERRY_VOL,
  NO_SENSOR: SensorType.NO_SENSOR,
};
